/**Tags and Categories export index */

import {
    acceptOrReject,
    approveClaims,
    checkClaim,
    claim,
    createOrganization,
    deleteOrg,
    editOrg, editOrgSocials,
    follow, getBusinesses,
    getClaims,
    getEdits,
    getFollows,
    getOrg,
    getOrgAdmins,
    getOrgByCategories,
    getOrgById,
    getOrgCategories,
    getOrgSocials,
    orgEvents,
    rejectClaims,
    removeById,
    removeOrgById,
    removeSuggestOrg,
    setStatus,
    suggestOrg,
    unfollow,
} from './organizations.action';

export { organizationsReducer } from './organizations.reducer';
export { watchOrg } from './organizations.saga';

export const organizationActions = {
    createOrganization,
    editOrg,
    deleteOrg,
    getOrg,
    getBusinesses,

    getOrgByCategories,
    getOrgById,
    removeOrgById,

    getClaims,
    approveClaims,
    rejectClaims,

    /**Edits */
    getEdits,
    acceptOrReject,

    /**Status */
    setStatus,

    /**Claim */
    claim,
    checkClaim,

    /**Suggest */
    suggestOrg,
    removeSuggestOrg,
    removeById,

    /**Events */
    orgEvents,

    /**Categories */
    getOrgCategories,

    /**Follow */
    getFollows,
    follow,
    unfollow,

    getOrgSocials,
    editOrgSocials,
    getOrgAdmins,
};
